import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Async thunk for fetching raw categories
export const fetchRawCategories = createAsyncThunk('rawCategories/fetchRawCategories', async (id) => {
  const response = await axios.get(`${API_URL}/raw-categories/${id}`);
  return response.data;
});

// Async thunk for creating a raw category
export const createRawCategory = createAsyncThunk('rawCategories/createRawCategory', async (rawCategoryData) => {
    
  const response = await axios.post(`${API_URL}/raw-categories`, rawCategoryData);
  return response.data;
});

// Async thunk for updating a raw category
export const updateRawCategory = createAsyncThunk('rawCategories/updateRawCategory', async ({ id, rawCategoryData }) => {
  const response = await axios.put(`${API_URL}/raw-categories/${id}`, rawCategoryData);
  return response.data;
});

// Async thunk for deleting a raw category
export const deleteRawCategory = createAsyncThunk('rawCategories/deleteRawCategory', async (id) => {
  await axios.delete(`${API_URL}/raw-categories/${id}`);
  return id;
});

// Create the slice
const rawCategorySlice = createSlice({
  name: 'rawCategories',
  initialState: {
    rawCategories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Handle fetch raw categories
    builder.addCase(fetchRawCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchRawCategories.fulfilled, (state, action) => {
      state.rawCategories = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchRawCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    // Handle create raw category
    builder.addCase(createRawCategory.fulfilled, (state, action) => {
      state.rawCategories.push(action.payload);
    });

    // Handle update raw category
    builder.addCase(updateRawCategory.fulfilled, (state, action) => {
      const index = state.rawCategories.findIndex((category) => category.id === action.payload.id);
      if (index !== -1) {
        state.rawCategories[index] = action.payload;
      }
    });

    // Handle delete raw category
    builder.addCase(deleteRawCategory.fulfilled, (state, action) => {
      state.rawCategories = state.rawCategories.filter((category) => category.id !== action.payload);
    });
  },
});

// Export the raw category reducer
export default rawCategorySlice.reducer;
